'use client'

import { LendBorrowDashboard } from '@/containers/LendBorrowDashboard'

export default function LendBorrowPage() {
  return <LendBorrowDashboard />
}

